
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z","fill":"#A9B1BD"}}),_c('path',{attrs:{"d":"M16.308 4.115v2.539h-1.51c-1.183 0-1.404.567-1.404 1.384v1.818h2.818l-.376 2.846h-2.442V20h-2.942v-7.298H8V9.856h2.452V7.76c0-2.433 1.49-3.76 3.663-3.76 1.039 0 1.933.077 2.193.115z","fill":"#fff"}})])
          )
        }
      }
    